import React, { useState } from "react";
import { X, Loader2 } from "lucide-react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (countryId: number) => Promise<void>;
  currentCountry: string;
  countries: any[];
  loading: boolean;
}

export const ChangeCountryModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  currentCountry,
  countries,
  loading,
}) => {
  const [selectedId, setSelectedId] = useState<string | "">("");

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedId) return;
    await onConfirm(Number(selectedId));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70]">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold">Changer le pays</h3>
          <button onClick={onClose}>
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <p className="mb-4 text-sm">Pays actuel : {currentCountry}</p>

          <select
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
            className="w-full p-2 border rounded mb-4"
            required
          >
            <option value="">Sélectionnez un pays</option>
            {countries.map((c) => (
              <option key={c.id} value={c.id}>
                {c.flag} {c.name}
              </option>
            ))}
          </select>

          <div className="flex gap-2">
            <button type="button" onClick={onClose} className="flex-1 py-2 bg-gray-200 rounded">
              Annuler
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
            >
              {loading ? "..." : "Valider"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
